import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { CommercialModel, NewCommercialModel } from '../../model/commercials/commercial'

export const apiFetchCommercialsBySubject = async (
  subjectID: number
): Promise<CommercialModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Commercials/GetCommercialsFiltered`, {
    subjectId: subjectID
  }).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetCommercialById = async (id: number): Promise<CommercialModel | null> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Commercials/${id}`).then(response => {
    if (response.data) {
      return response.data
    } else {
      return null
    }
  })
}

export const apiPostCommercial = async (
  request: NewCommercialModel
): Promise<CommercialModel | null> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Commercials/PostCommercial`, request).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return null
      }
    }
  )
}

export const apiUpdateCommercial = async (
  request: CommercialModel
): Promise<CommercialModel | null> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Commercials/UpdateCommercial`, request).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return null
      }
    }
  )
}

export const apiDeleteCommercial = async (
  commercialID: number
): Promise<CommercialModel | null> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(`${apiSuffixUrl}/api/Commercials/${commercialID}`).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return null
      }
    }
  )
}
